<section class="page">
  <form class="card form-grid" [formGroup]="form" (ngSubmit)="create()">
    <h1>Master Data</h1>
    <input formControlName="category" placeholder="Category">
    <input formControlName="code" placeholder="Code">
    <input formControlName="name" placeholder="Name">
    <input formControlName="description" placeholder="Description">
    <button type="submit" [disabled]="form.invalid">Create Item</button>
  </form>
  <div class="card">
    <table class="table-sm">
      <tr>
        <th>Sr.No</th>
        <th>Category</th>
        <th>Code</th>
        <th>Name</th>
        <th>Status</th>
      </tr>
      @for (item of paginatedItems; track item.id; let index = $index) {
        <tr>
          <td>{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
          <td>{{ item.category }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.is_active ? 'Active' : 'Inactive' }}</td>
        </tr>
      }
    </table>
    <div class="pagination">
      <span>Showing {{ paginatedItems.length }} of {{ items.length }} records</span>
      <div>
        <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">Previous</button>
        <strong>{{ currentPage }} / {{ totalPages }}</strong>
        <button type="button" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">Next</button>
      </div>
    </div>
  </div>
</section>
